const formatPriceWithCommas = (price: string) => {
  return price.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const getCurrencySymbol = (currency: string) => {
  if (currency === 'INR') {
    return '₹';
  }
};

export const getFormattedPrice = (price?: number | undefined) => {
  if (price === 0) {
    return `${getCurrencySymbol('INR')}0`;
  }
  if (!price) {
    return '';
  }

  const amount = price.toString();
  const formattedPrice = `${getCurrencySymbol('INR')}${
    price >= 0 ? formatPriceWithCommas(amount) : 0
  }`;
  return formattedPrice;
};

export const formatToDecimalPlaces = (value: any, places = 2) => {
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return num.toFixed(places);
};
